export const isMobile = () => document.body.clientWidth < 768;

export const leftMenuWidth = 240;
export const leftMenuCollapsedWidth = 71;
